import { render, staticRenderFns } from "./CategoryView.vue?vue&type=template&id=71ad04f0&scoped=true&"
import script from "./CategoryView.vue?vue&type=script&lang=js&"
export * from "./CategoryView.vue?vue&type=script&lang=js&"
import style0 from "./CategoryView.vue?vue&type=style&index=0&id=71ad04f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad04f0",
  null
  
)

export default component.exports